import React from 'react';
import ListGroup from '../ListGroup';

function Teaching() {
    return (
        <section> 
          
            <ListGroup heading='Instructor'/>
        </section>
    );
};

export default Teaching;